import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import SaveButton from "../../components/Buttons/SaveButton";
import ButtonBar from "../../components/Fields/ButtonBar";
import Form from "../../components/Fields/Form";
import PasswordField from "../../components/Fields/PasswordField";
import { FormConfig } from "../../components/Fields/Types";
import useValidation from "../../components/Hooks/ValidationHook/useValidation";
import { useAuth } from "../../contexts/authContext";
import { useNotifications } from "../../contexts/notificationContext";
import UserEditModel from "../../models/UserEditModel";
import DataService from "../../services/data.service";
import { DataResult, Result } from "../../types/Result";

interface ChangePasswordModel {
    id: number
    username: string
    password: string
    newPassword1: string
    newPassword2: string
    concurrencyId: string
}

const ChangeDefaultPasswordView: React.FC = () => {
    const [serverErrors, setServerErrors] = useState<Result>({ isSuccesful: true, messages: [] });
    const { handleResult, handleException } = useNotifications();
    const { user, changeNextTimeLogin } = useAuth()
    const navigate = useNavigate();

    const [formData, setFormData] = useState<ChangePasswordModel | undefined>({
        id: user?.userId ?? 0,
        username: user?.loginName ?? '',
        password: 'welcome',
        newPassword1: '',
        newPassword2: '',
        concurrencyId: ''
    });

    useEffect(() => {
        if (formData && user) {
            DataService.getById<UserEditModel>(`api/v1/Users/`, user.userId)
                .then(response => {
                    formData.concurrencyId = response.concurrencyId
                    setFormData({ ...formData });
                })
                .catch(e => handleException(e));
        }
    }, [user])

    function submit() {
        if (formData && user) {
            DataService
                .post<DataResult<ChangePasswordModel>>(`api/v1/Users/changepassword`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true) {
                        changeNextTimeLogin();
                        navigate('/plm/home');
                    }
                })
                .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'newPassword1', label: 'New password', labelSize: 3, validationRules: [{ type: 'isRequired' }] },
            { name: 'newPassword2', label: 'Repeat password', labelSize: 3, validationRules: [{ type: 'isRequired' }] },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <div className='main-content'>
            <Container>
                <Row>
                    <Col md={{ span: 6, offset: 3 }} sm={{ span: 6, offset: 3 }}>
                        <Form
                            title='Change password'
                            footer={(
                                <ButtonBar offset={0}>
                                    <SaveButton  {...getSubmitButtonProps()} />
                                </ButtonBar>
                            )}>
                            <PasswordField {...getFieldProps('newPassword1')} />
                            <PasswordField {...getFieldProps('newPassword2')} />
                        </Form>
                    </Col>
                </Row>
                </Container>
        </div>
    );
}
export default ChangeDefaultPasswordView;